import Service from "../../services";
import { checkAndReturn } from "../../main";

const state = {
    GeneralForm: {},
    AttachmentForm: {},
    EvaluationForm: {}
}
const getters = {};

const actions = {
  index({ commit }, params) {
    return Service.TechnologyEvaluation.index(params.payload).then((res) => {
      return checkAndReturn(params, res,true);
    });
  },
  show({ commit }, params) {
    return Service.TechnologyEvaluation.show(params.payload).then((res) => {
      return checkAndReturn(params, res,true);
    });
  },
  save({ commit }, params) {
    return Service.TechnologyEvaluation.save(params.payload).then((res) => {
      return checkAndReturn(params, res,true);
    });
  },
  create({ commit }, params) {
    return Service.TechnologyEvaluation.create(params.payload).then((res) => {
      return checkAndReturn(params, res,true);
    });
  },
  edit({ commit }, params) {
    return Service.TechnologyEvaluation.edit(params.payload).then((res) => {
      return checkAndReturn(params, res,true);
    });
  },
  update({ commit }, params) {
    return Service.TechnologyEvaluation.update(params.payload).then((res) => {
      return checkAndReturn(params, res,true);
    });
  },
  delete({ commit }, params) {
    return Service.TechnologyEvaluation.delete(params.payload).then((res) => {
      return checkAndReturn(params, res,true);
    });
  }
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
